import React from "react"
import { GroupContainer, TextAreaContainer, TextAreaInputLabel } from "./TextAreaInputElements"

const TextAreaInput = ({ handleChange, label, ...otherProps }) => {
  return (
    <GroupContainer>
      {label ? (
        <TextAreaInputLabel className={otherProps.value.length ? "shrink" : ""}>{label}</TextAreaInputLabel>
      ) : null}
      <TextAreaContainer onChange={handleChange} {...otherProps}></TextAreaContainer>
    </GroupContainer>
  )
}

export default TextAreaInput
